const state = {
  items: [],
  storeAllVehicles: [],
};

const mutations = {
  // SET_USER_ITEMS: (state, payload) => {
  // 	console.log("herer >>> ", payload)
  // 	// state.items = payload.data;
  // 	// const pages = Object.assign(payload.pages, payload.items);
  // 	// state.paging = Object.assign({}, pages);
  // },
  SET_DATA: (state, payload) => {
    state.items = payload;
  },
  SET_VEHICLE_LIST: (state, payload) => {
    state.storeAllVehicles = payload;
  },
};

const actions = {
  setData({ commit }, payload) {
    commit("SET_DATA", payload);
  },
  setVehicleList({
    commit
  }, payload) {
    commit("SET_VEHICLE_LIST", payload);
  }
};

const getters = {
  getData: state => state.items,
  storeVehileDataList: state => state.storeAllVehicles,
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./src/store/module/vehicleBooking.js